import { defineStore } from 'pinia'
import { useMenuNavApi } from '@/api/sys/menu'
import { generateRoutes, constantMenu, dashboardMenu } from '@/router'
import { RouteRecordRaw } from 'vue-router'

const filterMenu = (menus: any[]): any[] => {
	return menus.filter(item => {
		if (item.display === 1) {
			return false
		}
		if (item.children && item.children.length > 0) {
			item.children = filterMenu(item.children)
		}
		return true
	})
}

export const useRouterStore = defineStore('routerStore', {
	state: () => ({
		menuRoutes: [] as RouteRecordRaw[],
		searchMenu: [] as RouteRecordRaw[],
		routes: [] as RouteRecordRaw[]
	}),
	actions: {
		async getMenuRoutes() {
			// 如果已有菜单数据，则直接返回
			if (this.menuRoutes && this.menuRoutes.length > 0) {
				console.log('菜单数据已存在，直接使用缓存数据')
				return this.menuRoutes
			}

			// 否则从服务器获取菜单数据
			const { data } = await useMenuNavApi()
			const routes = generateRoutes(filterMenu(data))

			// 控制台菜单
			const dashboardRoutes = generateRoutes(dashboardMenu)
			// this.menuRoutes.push(...dashboardRoutes)

			// 后端菜单 - 避免重复添加
			this.menuRoutes = [...routes]

			// 常量菜单
			const constantRoutes = generateRoutes(constantMenu)

			// if (import.meta.env.MODE == 'development') {
			this.menuRoutes.push(...constantRoutes)
			// }

			console.log('从服务器获取了新的菜单数据，数量:', this.menuRoutes.length)
			return this.menuRoutes
		},
		setSearchMenu(routers: RouteRecordRaw[]) {
			this.searchMenu = routers
		},
		setRoutes(routers: RouteRecordRaw[]) {
			this.routes = routers
		},
		// 清空缓存的路由数据，用于处理重复加载问题
		clearMenuRoutes() {
			this.menuRoutes = []
			this.searchMenu = []
			this.routes = []
			console.log('已清空路由缓存数据')
		}
	}
})
